export function vectorFlatLength(vector: [number, number, number]) {
  return Math.sqrt(vector[0] * vector[0] + vector[2] * vector[2]);
}
